import { render, staticRenderFns } from "./EZUIKitJs.vue?vue&type=template&id=f8dc0654&"
import script from "./EZUIKitJs.vue?vue&type=script&lang=js&"
export * from "./EZUIKitJs.vue?vue&type=script&lang=js&"
import style0 from "./EZUIKitJs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports